import React from 'react'

const FormDashboardLabel = ({noMargin, children}) => {
  return (
    <label className={`block w-full font-bold text-sm ${noMargin ? 'm-0' : 'mb-2'}`}>
      {children}
    </label>
  )
}

export { FormDashboardLabel }
